/**
 * Same-Letter puzzles — every (or most) word(s) begin with the same letter.
 * A classic show category that rewards careful reading. We bias toward
 * phrases that are genuinely recognizable — a familiar saying, a real
 * common-domain phrase, or a tightly idiomatic image. Quality over quantity.
 *
 * Editorial pass per review §3.C1: dropped filler repetitions
 * ("GLAD GLAD GLAD GLAD", "HOLLY HOLLY HOLLY HOLLY"), broken-English
 * constructions ("EVERYBODY EATS EARLY EGGS"), missing apostrophes
 * ("LEARNING LIFES LITTLE LESSONS"), and entries that read as synthetic
 * filler rather than a phrase a 78-year-old would recognize. Replaced a
 * handful with curated phrases drawn from familiar idiom and the show's
 * own canonical Same-Letter family.
 */
export const SAME_LETTER = [
  'BRIGHT BRASS BUTTONS',
  'BUSY BAKING BUTTER BISCUITS',
  'BRAINS BEAUTY BRAWN',
  'COZY CABIN IN THE COUNTRY',
  'COURAGEOUS CAVALRY CAPTAIN',
  'CHERRY CHEESECAKE CHRISTMAS',
  'CHARMING CONVERSATION',
  'CASUAL CONVERSATION',
  'CARROT CAKE',
  'DREAMY DAFFODILS DANCING',
  'DOWN BY THE DRY DOCK',
  'EARLY EVENING ENCOUNTER',
  'ELEGANT EVENING ENSEMBLE',
  'FANCY FRENCH FROSTING',
  'FRESH FROM THE FARM',
  'FRIENDLY FAMILY FRIDAY',
  'FAMOUS LAST WORDS',
  'GENTLE GENEROUS GRANDMOTHER',
  'GOLDEN GATE GLOWING',
  'HAPPY HUMMING HARMONICA',
  'HOMEMADE HONEY HAM',
  'JUMPING JUNE BUGS',
  'LATE LAZY LONG SUMMER LUNCH',
  'LITTLE LACY LAVENDER',
  'LOVELY LIGHT LATE AFTERNOON',
  'MAGNIFICENT MOUNTAIN MEADOWS',
  'MILLIONS OF MAPLE MUFFINS',
  'MORNING MIST IN MAY',
  'MARTHA STEWART',
  'NICE NEAT NEW NEIGHBORS',
  'OUT ON THE OPEN OCEAN',
  'PEACE AND PROSPERITY',
  'PEPPERMINT PATTIES AND PIE',
  'POLITE POLISHED PROPER',
  'PRACTICAL PERSONAL PURSUITS',
  'PRETTY PINK PEONIES',
  'PIZZA PARTY',
  'PIECE OF PIE',
  'QUICKLY QUIETLY QUEENLY',
  'REAL RED ROSES IN THE RAIN',
  'RUSTY RUSTIC ROADSIDE',
  'SUNDAY STROLL DOWNTOWN',
  'SUNNY SOUTHERN SUMMER',
  'SWEET SOUTHERN SUNSHINE',
  'SHORT SHARP SHOCK',
  'SILVER SCREEN STAR',
  'TINY TURTLES IN A TIDE POOL',
  'WARM WELCOMING WORDS',
  'WONDERFUL WORLD OF WORDS',
  'WALK WHEN THE WIND IS WARM',
  'WISDOM WITHIN A WHISPER',
  'BANANAS BERRIES AND BREAD',
  'CARING COMMUNITY CIRCLE',
  'DARLING DOG DAYS',
  'FRESH FLOWERS FROM THE FIELD',
  'GLORIOUS GLEAMING GOLD',
  'HARVEST HOMECOMING HOLIDAYS',
  'PEACEFUL POOL OF PERFECTION',
  'QUIET QUAINT QUARTERS',
  'SOFT SUMMER SHOWERS',
] as const;
